module.exports = __webpack_public_path__ + "static/media/Värde-Baserad Kultur - 3h workshop.f8732283.pdf";